import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { cn } from '@marvelapp/ballpark-components';
export const CardSortingSidebar = observer(function CardSortingSidebar(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (_jsx("aside", Object.assign({ className: cn('pt-4', 'px-4', 'pb-[76px]', 'max-h-full', 'overflow-auto', 'w-[calc(50%+8px)]', 'lg:w-[calc(33%+16px)]', 'xl:w-[calc(25%+16px)]', '2xl:w-[calc(20%+16px)]', className) }, rest)));
});
